exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".signature-container[data-v-0f348213]{background:#e0e0e0;position:relative}.signature-container .safe-area[data-v-0f348213],.signature-container canvas[data-v-0f348213]{position:absolute;top:0;left:0;bottom:0;right:0;background:transparent}.signature-container .safe-area[data-v-0f348213]{border-bottom:1px solid #000;margin:0 30px 40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f348213","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/dobrodelen/SignaturePad.vue
// module id = 135
// module chunks = 1 3